import { Box, Container, Typography, Grid } from "@mui/material";
import { useEffect } from "react";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import HotelIcon from "@mui/icons-material/Hotel";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import SpaIcon from "@mui/icons-material/Spa";
import StarIcon from "@mui/icons-material/Star";
//import SectionTitle from "../components/SectionTitle";

/* ── Testimonials data ───────────────────────────────────── */
const TEMOIGNAGES = [
  // Hôtel
  {
    category: "Hôtel",
    icon: HotelIcon,
    name: "NOBU Hotel Marrakech",
    slug: "nobu",
    role: "Direction Housekeeping",
    review: "Luxury Laundry est notre partenaire de confiance depuis plusieurs années. La qualité du linge, la ponctualité des livraisons et le soin apporté à chaque article sont irréprochables. Nos clients remarquent la différence.",
    stars: 5,
  },
  {
    category: "Hôtel",
    icon: HotelIcon,
    name: "Adam Park Marrakech",
    slug: "adam-park",
    role: "Responsable des Opérations",
    review: "Un service hôtelier d'exception. Luxury Laundry comprend les exigences du secteur luxury et y répond avec professionnalisme. Disponibles 24h/24, ils ne nous ont jamais laissé tomber.",
    stars: 5,
  },
  {
    category: "Hôtel",
    icon: HotelIcon,
    name: "Hivernage Hotel & Spa",
    slug: "hivernage",
    role: "Directeur Général",
    review: "La gestion du linge hôtelier est un défi quotidien. Avec Luxury Laundry, nous avons trouvé un partenaire fiable qui maintient nos standards d'excellence. Collecte rapide, linge impeccable.",
    stars: 5,
  },
  // Restaurant
  {
    category: "Restaurant",
    icon: RestaurantIcon,
    name: "Dar soukkar",
    slug: "dar-sekkar",
    role: "Chef & Propriétaire",
    review: "Nos nappes et serviettes sont toujours parfaitement repassées et d'une blancheur éclatante. Le service est rapide et le personnel est très professionnel. Je recommande vivement.",
    stars: 5,
  },
  {
    category: "Restaurant",
    icon: RestaurantIcon,
    name: "Golf Nouria",
    slug: "golf-nouria",
    role: "Responsable F&B",
    review: "Luxury Laundry gère l'entretien de tout notre linge de table avec une efficacité remarquable. La qualité est constante et le service de collecte s'adapte parfaitement à notre planning.",
    stars: 5,
  },
  {
    category: "Restaurant",
    icon: RestaurantIcon,
    name: "Noto Restaurant",
    slug: "noto",
    role: "Directeur de Salle",
    review: "Depuis que nous travaillons avec Luxury Laundry, notre linge de table est toujours impeccable. Nos clients apprécient le soin apporté aux détails. Un partenaire de qualité.",
    stars: 5,
  },
  {
    category: "Restaurant",
    icon: RestaurantIcon,
    name: "Sikiz",
    slug: "sikiz",
    role: "Gérant",
    review: "Un service irréprochable et une équipe très réactive. Notre linge est toujours livré à temps, propre et bien plié. Luxury Laundry répond parfaitement aux exigences de notre restaurant.",
    stars: 5,
  },
  {
    category: "Restaurant",
    icon: RestaurantIcon,
    name: "Trattoria",
    slug: "tratorria",
    role: "Directrice",
    review: "Nous faisons confiance à Luxury Laundry pour l'entretien de notre linge depuis l'ouverture. Sérieux, ponctuel et de très haute qualité. Exactement ce dont un restaurant de notre standing a besoin.",
    stars: 5,
  },
  // Spas
  {
    category: "Spa",
    icon: SpaIcon,
    name: "Zina Spa",
    slug: "zina-spa",
    role: "Responsable Spa",
    review: "La douceur et la propreté des serviettes et peignoirs que nous recevons de Luxury Laundry contribuent directement au bien-être de nos clients. Un partenaire indispensable pour notre activité.",
    stars: 5,
  },
  {
    category: "Spa",
    icon: SpaIcon,
    name: "Mawli Spa",
    slug: "mawli-spa",
    role: "Directrice Spa",
    review: "Luxury Laundry comprend les besoins spécifiques d'un spa de luxe. Leur linge est d'une douceur exceptionnelle et toujours livré dans les délais. Une collaboration que nous recommandons sans hésitation.",
    stars: 5,
  },
];

const CATEGORIES_ORDER = ["Hôtel", "Restaurant", "Spa"];

/* ── Hero Banner ─────────────────────────────────────────── */
const HeroBanner = () => (
  <Box sx={{
    position: "relative",
    height: { xs: "40vh", md: "65vh" },
    display: "flex", alignItems: "center", justifyContent: "center", textAlign: "center",
    overflow: "hidden",
    background: 'url("/images/temoignage.png") center/cover no-repeat',
    "&::before": {
      content: '""', position: "absolute", inset: 0,
      background: "linear-gradient(to bottom, rgba(10,6,2,0.6) 0%, rgba(10,6,2,0.4) 50%, rgba(10,6,2,0.85) 100%)",
      zIndex: 1,
    },
  }}>
    <Container maxWidth="md" sx={{ position: "relative", zIndex: 2 }}>
      <Typography sx={{ color: "secondary.main", fontSize: "0.68rem", letterSpacing: "0.3em", textTransform: "uppercase", fontWeight: 700, mb: 1.5 }}>
        Ils Nous Font Confiance
      </Typography>
      <Typography variant="h1" sx={{ color: "#fff", fontFamily: "'Playfair Display', serif", fontWeight: 700, fontSize: { xs: "2rem", md: "3rem" }, mb: 2, lineHeight: 1.1 }}>
        Témoignages
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1.5 }}>
        <Box sx={{ width: 50, height: "1px", backgroundColor: "rgba(201,168,76,0.5)" }} />
        <Box sx={{ width: 5, height: 5, backgroundColor: "secondary.main", transform: "rotate(45deg)" }} />
        <Box sx={{ width: 50, height: "1px", backgroundColor: "rgba(201,168,76,0.5)" }} />
      </Box>
    </Container>
    <Box sx={{ position: "absolute", bottom: -1, left: 0, right: 0, zIndex: 3, lineHeight: 0 }}>
      <svg viewBox="0 0 1440 50" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{ display: "block", width: "100%", height: 50 }}>
        <path d="M0,30 C360,55 1080,5 1440,30 L1440,50 L0,50 Z" fill="#f5f0e8" />
      </svg>
    </Box>
  </Box>
);

/* ── Review Card ─────────────────────────────────────────── */
const ReviewCard = ({ name, slug, role, review, stars, icon: Icon }) => (
  <Box sx={{
    backgroundColor: "#fff",
    border: "1px solid rgba(201,168,76,0.2)",
    borderRadius: "10px",
    p: 3.5,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 2px 16px rgba(26,17,8,0.07)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: "0 12px 36px rgba(26,17,8,0.12)",
      borderColor: "secondary.main",
    },
  }}>
    {/* Top: logo placeholder + stars */}
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2.5 }}>
      {/* Logo placeholder */}
      <Box sx={{
        width: 100, height: 65,
        border: "1px solid rgba(201,168,76,0.2)",
        borderRadius: "6px",
        backgroundColor: "#f5f0e8",
        display: "flex", alignItems: "center", justifyContent: "center",
        overflow: "hidden",
      }}>
        <Box
          component="img"
          src={`/images/partenaires/${slug}.png`}
          alt={name}
          sx={{ maxWidth: "90%", maxHeight: "90%", objectFit: "contain", display: "block" }}
          onError={(e) => {
            e.target.style.display = "none";
            e.target.parentElement.querySelector(".logo-fallback").style.display = "flex";
          }}
        />
        <Box className="logo-fallback" sx={{ display: "none", width: "100%", height: "100%", alignItems: "center", justifyContent: "center" }}>
          <Icon sx={{ fontSize: 24, color: "rgba(201,168,76,0.5)" }} />
        </Box>
      </Box>

      {/* Stars */}
      <Box sx={{ display: "flex", gap: 0.3 }}>
        {Array.from({ length: stars }).map((_, i) => (
          <StarIcon key={i} sx={{ fontSize: 16, color: "secondary.main" }} />
        ))}
      </Box>
    </Box>

    {/* Quote icon */}
    <FormatQuoteIcon sx={{ fontSize: 36, color: "rgba(201,168,76,0.25)", mb: 1, transform: "rotate(180deg)" }} />

    {/* Review text */}
    <Typography sx={{ color: "text.secondary", fontSize: "0.88rem", lineHeight: 1.85, flexGrow: 1, fontStyle: "italic", mb: 2.5 }}>
      "{review}"
    </Typography>

    {/* Divider */}
    <Box sx={{ width: 30, height: "1px", backgroundColor: "rgba(201,168,76,0.35)", mb: 2 }} />

    {/* Name & role */}
    <Box>
      <Typography sx={{ fontFamily: "'Playfair Display', serif", fontWeight: 600, fontSize: "0.95rem", color: "text.primary" }}>
        {name}
      </Typography>
      <Typography sx={{ color: "secondary.main", fontSize: "0.75rem", letterSpacing: "0.08em", mt: 0.3 }}>
        {role}
      </Typography>
    </Box>
  </Box>
);

/* ── Page ────────────────────────────────────────────────── */
const TemoignagesPage = () => {
  // Scroll automatique vers la section si un hash est présent dans l'URL
  useEffect(() => {
    const hash = window.location.hash.replace("#", "");
    if (hash) {
      setTimeout(() => {
        const element = document.getElementById(hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 100);
    }
  }, []);

  return (
    <Box>
      <HeroBanner />

      <Box sx={{
        position: "relative", backgroundColor: "#f5f0e8",
        "&::before": { content: '""', position: "absolute", inset: 0, zIndex: 0, pointerEvents: "none", background: 'url("/images/FlowerB.jpg") center/cover no-repeat', opacity: 0.03 },
      }}>
        <Box sx={{ position: "relative", zIndex: 1, py: { xs: 7, md: 10 } }}>
          <Container maxWidth="lg">

            {CATEGORIES_ORDER.map((cat) => {
              const items = TEMOIGNAGES.filter(t => t.category === cat);
              const CatIcon = items[0]?.icon;
              const sectionId = cat.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
              
              return (
                <Box key={cat} id={sectionId} sx={{ mb: { xs: 8, md: 10 }, scrollMarginTop: "80px" }}>
                  {/* Category header */}
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 5 }}>
                    <Box sx={{
                      width: 48, height: 48, borderRadius: "50%",
                      backgroundColor: "rgba(201,168,76,0.1)",
                      border: "1px solid rgba(201,168,76,0.3)",
                      display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
                    }}>
                      {CatIcon && <CatIcon sx={{ fontSize: 22, color: "secondary.main" }} />}
                    </Box>
                    <Box sx={{ flexGrow: 1 }}>
                      <Typography sx={{ fontFamily: "'Playfair Display', serif", fontWeight: 700, fontSize: "1.4rem", color: "text.primary" }}>
                        {cat}
                      </Typography>
                    </Box>
                    <Box sx={{ flexGrow: 1, height: "1px", backgroundColor: "rgba(201,168,76,0.2)" }} />
                  </Box>

                  {/* Cards */}
                  <Grid container spacing={3}>
                    {items.map((t) => (
                      <Grid item xs={12} sm={6} md={4} key={t.name} sx={{ display: "flex" }}>
                        <ReviewCard {...t} />
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              );
            })}

          </Container>
        </Box>
      </Box>
    </Box>
  );
};

export default TemoignagesPage;